import { delay, HttpResponse } from "msw";

export const getModels = async () => {
  await delay("real");

  return HttpResponse.json({
    models: [
      {
        name: "gpt-4.1-mini-2025-04-14",
        supported_file_types: [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/pdf",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        model_provider: "OpenAI",
      },
      {
        name: "o3-mini-2025-01-31",
        supported_file_types: [
          "application/pdf",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        model_provider: "OpenAI",
      },
      {
        name: "gemini-2.0-flash",
        supported_file_types: ["pdf", "xlsx", "docx"],
        model_provider: "Google",
      },
      {
        name: "claude-3-7-sonnet",
        supported_file_types: [],
        model_provider: "Anthropic",
      },
    ],
    default_model: "gpt-4.1-mini-2025-04-14",
  });
};
